import {createFeatureSelector, createSelector} from "@ngrx/store";
import {AppState} from "../../index";

export const getAppState = createFeatureSelector<AppState>('app');
//User
export const getUserSettings = createSelector(
  getAppState,
  (state: AppState) => state.user
);
